// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","icon":"icon-2EjgN","content":"content-2SVPy","scrollBody":"scrollBody-3-oQS","paper":"paper-3LACd"};